"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { THEME_BOOT_SCRIPT } from "@/lib/theme-boot-script";
function subscribe(): () => void {
  return () => {
    // The client/server snapshot never changes, so there is nothing to subscribe to.
  };
}
function getClientSnapshot(): boolean {
  return true;
}
function getServerSnapshot(): boolean {
  return false;
}

/**
 * Parser-blocking theme boot. The server (and hydration) emit a real
 * `<script>` so the browser runs it while parsing `<head>`, before first
 * paint. Client navigations omit the tag: React 19 warns — and does not
 * execute — a `<script>` created during a client render. `next/script`
 * `beforeInteractive` still emits a client `<script>` (the `__next_s` queue)
 * and runs the boot body only after the Next bootstrap, which is too late
 * to avoid a theme flash.
 */
export function ThemeBootScript() {
  const $ = _c(1);
  const isClient = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
  if (isClient) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <script dangerouslySetInnerHTML={{
      __html: THEME_BOOT_SCRIPT
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}